import { Component } from '@angular/core';
import { NewModalRef } from 'outshared-lib';
import { ConfirmationModalInterface } from '@app/core/interfaces/confirmation-modal.interface';

@Component({
    selector: 'ins-confirmation-modal',
    templateUrl: './confirmation.component.html'
})
export class ConfirmationModalComponent {

    model: ConfirmationModalInterface = {
        id: '',
        title: '',
        body: '',
        bevestiging: 'OK',
        ontkenning: null
    };

    constructor(
        private activeModal: NewModalRef<ConfirmationModalComponent>
    ) {}

    public close(): void {
        this.activeModal.close(true);
    }

    public dismiss(): void {
        this.activeModal.close();
    }
}
